import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserResidentVM } from 'src/app/view/admin/services/models/view-models';

@Component({
  selector: 'app-user-residents',
  templateUrl: './user-residents.component.html',
  styleUrls: ['./user-residents.component.scss']
})
export class UserResidentsComponent implements OnInit {
  @Input() userResidents: UserResidentVM[] = [];
  @Input() canDelete = true;
  @Output() onDelete = new EventEmitter<UserResidentVM>();

  public showIds = false;

  constructor() {}

  ngOnInit(): void {}
}
